/**
 * Modal SweetAlert: resumen de nueva cotización del seguro complementario (sin claim en UI).
 */
(function () {
  function escapeHtml(str) {
    if (str == null) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function formatClp(n) {
    if (n == null || n === '' || isNaN(Number(n))) return '—';
    return '$' + Math.round(Number(n)).toLocaleString('es-CL');
  }

  function aggregateYappDetailBySku(yappPayload) {
    var bySku = {};
    var det = yappPayload && yappPayload.detail;
    if (!Array.isArray(det)) return bySku;
    det.forEach(function (d) {
      (d.products || []).forEach(function (p) {
        var sku = String(p.sku || '').trim();
        if (!sku) return;
        var qty = Number(p.quantity != null ? p.quantity : 1);
        if (isNaN(qty) || qty < 0) qty = 0;
        var rec = p.receivable != null ? Number(p.receivable) : 0;
        if (isNaN(rec)) rec = 0;
        if (!bySku[sku]) bySku[sku] = { qty: 0, receivable: 0 };
        bySku[sku].qty += qty;
        bySku[sku].receivable += rec;
      });
    });
    return bySku;
  }

  function aggregateCartLinesBySkuForComparison(cartProductos, skusExcluirSet) {
    var m = {};
    if (!Array.isArray(cartProductos)) return m;
    skusExcluirSet = skusExcluirSet || {};
    cartProductos.forEach(function (line) {
      var sku = String(line.sku || '').trim();
      if (!sku || skusExcluirSet[sku]) return;
      var q = Number(line.quantity != null ? line.quantity : 1);
      if (isNaN(q) || q < 0) q = 0;
      m[sku] = (m[sku] || 0) + q;
    });
    return m;
  }

  function flattenYappDetailLines(yappPayload) {
    var lines = [];
    var det = yappPayload && yappPayload.detail;
    if (!Array.isArray(det)) return lines;
    det.forEach(function (d) {
      var doc = String(d.tributary_document || '');
      var docLabel = doc === 'bill' ? 'Boleta' : doc === 'dispatch_note' ? 'Guía' : doc || '—';
      (d.products || []).forEach(function (p) {
        var qty = Number(p.quantity != null ? p.quantity : 1);
        if (isNaN(qty) || qty < 1) qty = 1;
        var rec = p.receivable != null ? Number(p.receivable) : 0;
        if (isNaN(rec)) rec = 0;
        lines.push({
          sku: String(p.sku || '').trim(),
          quantity: qty,
          receivable: rec,
          unitPrice: rec / qty,
          detailId: d.id,
          docLabel: docLabel,
          tributaryDocument: doc
        });
      });
    });
    return lines;
  }

  function buildTitleBySku(cartProductos) {
    var titleBySku = {};
    if (!Array.isArray(cartProductos)) return titleBySku;
    cartProductos.forEach(function (line) {
      var sku = String(line && line.sku ? line.sku : '').trim();
      if (!sku || titleBySku[sku]) return;
      var title = String(line && line.title ? line.title : '').trim();
      if (title) titleBySku[sku] = title;
    });
    return titleBySku;
  }

  function buildHtmlResumenNuevaCotizacionYapp(yappPayload, cartProductos) {
    var det = yappPayload && yappPayload.detail;
    if (!Array.isArray(det) || det.length === 0) {
      return '<p style="margin:0;font-size:14px">Cotización actualizada correctamente. Revisa el detalle en el correo de confirmación o vuelve a aplicar convenio si los totales del carrito no coinciden.</p>';
    }

    var yappLines = flattenYappDetailLines(yappPayload);
    var bySku = aggregateYappDetailBySku(yappPayload);
    var titleBySku = buildTitleBySku(cartProductos);
    var getLabel = function (sku) {
      var k = String(sku || '').trim();
      if (!k) return 'Producto';
      var t = titleBySku[k];
      t = t && String(t).trim();
      return t ? t : k;
    };
    var skusFueraConvenio =
      yappPayload && Array.isArray(yappPayload.skus_catalogo_fuera_convenio)
        ? yappPayload.skus_catalogo_fuera_convenio
        : [];
    var fueraSet = {};
    skusFueraConvenio.forEach(function (sku) {
      fueraSet[String(sku)] = true;
    });
    var cartBySku = aggregateCartLinesBySkuForComparison(cartProductos, fueraSet);
    var total = 0;
    var rows = [];
    var mismatches = [];

    yappLines.forEach(function (line) {
      total += line.receivable;
      var productLabel = getLabel(line.sku);
      rows.push(
        '<tr>' +
          '<td class="yapp-col-sku">' + escapeHtml(productLabel) + '</td>' +
          '<td class="yapp-col-doc">' + escapeHtml(line.docLabel) + '</td>' +
          '<td class="yapp-col-qty">' + escapeHtml(line.quantity) + '</td>' +
          '<td class="yapp-col-money">' + formatClp(line.unitPrice) + '</td>' +
          '<td class="yapp-col-money">' + formatClp(line.receivable) + '</td>' +
        '</tr>'
      );
    });

    Object.keys(bySku).forEach(function (sku) {
      var agg = bySku[sku];
      var enCarrito = cartBySku[sku];
      if (enCarrito != null && enCarrito !== agg.qty) {
        mismatches.push(
          '<li><strong>' +
            escapeHtml(getLabel(sku)) +
            '</strong>: en carrito <strong>' +
            escapeHtml(enCarrito) +
            '</strong> u., en cotización del convenio <strong>' +
            escapeHtml(agg.qty) +
            '</strong> u. (suma de todas las líneas).</li>'
        );
      }
    });

    Object.keys(cartBySku).forEach(function (sku) {
      if (bySku[sku] == null && !fueraSet[sku]) {
        mismatches.push(
          '<li><strong>' +
            escapeHtml(getLabel(sku)) +
            '</strong>: está en tu carrito (' +
            escapeHtml(cartBySku[sku]) +
            ' u.) pero <strong>no aparece</strong> en la cotización del convenio.</li>'
        );
      }
    });

    var notaFueraConvenio = '';
    if (skusFueraConvenio.length > 0) {
      notaFueraConvenio =
        '<p class="yapp-resumen-note" style="margin-top:8px">Productos de catálogo <strong>fuera del convenio</strong> : ' +
        skusFueraConvenio
          .map(function (s) {
            return escapeHtml(getLabel(s));
          })
          .join(', ') +
        '. Se mantienen en el carrito con precio de lista, sin recotizar.</p>';
    }

    var head =
      '<div class="yapp-resumen-wrap">' +
      '<div class="yapp-resumen-intro" style="margin-bottom:12px;padding:12px 14px;background:#f5f9fc;border:1px solid #d4e4ef;border-radius:6px;">' +
      '<p style="margin:0 0 8px;font-size:15px;color:#1a3a52;line-height:1.5">' +
      '<strong>Se han detectado cambios</strong> en los productos de su carrito. ' +
      'Por este motivo, <strong>se ha efectuado una nueva cotización</strong> con su seguro complementario.' +
      '</p>' +
      '<p style="margin:0;font-size:13px;color:#555;line-height:1.45">' +
      'El convenio puede distribuir el <strong>mismo medicamento</strong> en varias líneas (Boleta / Guía). ' +
      'En el carrito verá <strong>una fila por cada línea</strong>, con el precio correspondiente a cada documento.' +
      '</p>' +
      '</div>' +
      '<p style="margin:0 0 8px;font-size:14px;color:#333;font-weight:600">Detalle de la nueva cotización:</p>';

    var warn =
      mismatches.length > 0
        ? '<div class="yapp-resumen-warn"><strong>Atención cantidades</strong><ul>' +
          mismatches.join('') +
          '</ul></div>'
        : '';

    var table =
      '<div class="yapp-resumen-table-scroll">' +
      '<table class="yapp-resumen-table"><thead><tr>' +
      '<th class="yapp-col-sku">Producto</th>' +
      '<th class="yapp-col-doc">Documento</th>' +
      '<th class="yapp-th-qty yapp-col-qty">Cant.</th>' +
      '<th class="yapp-th-money yapp-col-money">Precio/u.</th>' +
      '<th class="yapp-th-money yapp-col-money">Total línea</th>' +
      '</tr></thead><tbody>' +
      rows.join('') +
      '</tbody></table></div>';

    var foot =
      '<p class="yapp-resumen-foot">Total cotización del convenio: ' +
      formatClp(total) +
      '</p>' +
      '<p class="yapp-resumen-note"><strong>Siguiente paso:</strong> al pulsar <strong>Actualizar carrito y continuar</strong> se aplicará de nuevo su seguro complementario y se actualizará el carrito con los precios cotizados.</p>' +
      '</div>';

    return head + warn + table + notaFueraConvenio + foot;
  }

  window.FarmexCartYappResumen = {
    buildHtml: buildHtmlResumenNuevaCotizacionYapp
  };
})();
